import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import {
  getTemplate,
  getTemplatePadrao,
  salvarTemplate,
  TemplateConfigNome,
} from '../../services/Templates/getTemplates'

export interface CampoTemplate {
  nome: TemplateConfigNome
  label: string
  tipo: 'input' | 'textarea'
  // Renderiza um preview HTML ao lado da textarea (corpo do e-mail).
  preview?: boolean
  // Placeholders disponíveis (mostrados como ajuda). Ausente = campo sem variáveis.
  placeholders?: string[]
  // Campos de cada item do laço. Ausente = os do e-mail/WhatsApp (PredicaoPedidoProdutoEnvioEmailDTO).
  produtoPlaceholders?: string[]
  // Observação de formato exibida no fim da ajuda (ex.: o PDF exige XHTML bem formado).
  nota?: string
  rows?: number
}

export const useEditorTemplate = (campos: CampoTemplate[]) => {
  const [valores, setValores] = useState<Record<string, string>>({})
  const [carregando, setCarregando] = useState(true)
  const [salvando, setSalvando] = useState(false)

  const carregar = async () => {
    setCarregando(true)
    const resultados = await Promise.all(
      campos.map(campo => getTemplate(campo.nome))
    )
    const novos: Record<string, string> = {}
    resultados.forEach((resultado, i) => {
      if ('message' in resultado) {
        toast.error(resultado.message)
        novos[campos[i].nome] = ''
      } else {
        novos[campos[i].nome] = resultado.valor
      }
    })
    setValores(novos)
    setCarregando(false)
  }

  useEffect(() => {
    carregar()
  }, [])

  const handleChange = (nome: TemplateConfigNome, valor: string) => {
    setValores(anterior => ({ ...anterior, [nome]: valor }))
  }

  const copiarPadrao = async (nome: TemplateConfigNome) => {
    const resultado = await getTemplatePadrao(nome)
    if ('message' in resultado) {
      toast.error(resultado.message)
      return
    }
    setValores(anterior => ({ ...anterior, [nome]: resultado.valor }))
    toast.info('Padrão do sistema copiado. Revise e salve para aplicar.')
  }

  const salvar = async () => {
    setSalvando(true)
    const resultados = await Promise.all(
      campos.map(campo => salvarTemplate(campo.nome, valores[campo.nome] ?? ''))
    )
    setSalvando(false)
    const falhas = resultados.filter(resultado => 'message' in resultado)
    if (falhas.length > 0) {
      const primeira = falhas[0] as { message: string }
      toast.error(primeira.message)
      // Recarrega para refletir o estado real do servidor (evita inconsistência
      // entre campos quando só parte do salvamento falha).
      carregar()
      return
    }
    toast.success('Template salvo!')
  }

  return {
    valores,
    carregando,
    salvando,
    handleChange,
    copiarPadrao,
    salvar,
  }
}
